export enum FilterDataTypes {
    String = "String",
    Number = "Number",
    Date = "Date",
    Boolean = "Boolean"
}